import React from "react";
import { Typography, Grid, Button, Modal, Box } from "@material-ui/core";
import Goals from "./Goals";
import AddGoal from "./AddGoal";
import AddIcon from "@material-ui/icons/Add";


const MyGoals = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <Typography variant="h4" color="initial" className="font-weight-bold">
          My Goals
        </Typography>
        <Button variant="contained"
          color="primary"
          startIcon={<AddIcon style={{ color: "white" }} />} onClick={handleOpen}>
          <b className="text-white">Add Goals</b>
        </Button>
      </div>
      <Grid container justify="space-between" className="mt-6" spacing={4}>
        <Grid item sm={6} md={4} lg={3}>
          <Goals />
        </Grid>
        <Grid item sm={6} md={4} lg={3}>
          <Goals />
        </Grid>
        <Grid item sm={6} md={4} lg={3}>
          <Goals />
        </Grid>
        <Grid item sm={6} md={4} lg={3}>
          <Goals />
        </Grid>
      </Grid>
      <AddGoal handleClose={handleClose} open={open} />
    </div>
  );
};

export default MyGoals;
